import script from "./roll_results_item.vue?vue&type=script&setup=true&lang=js"
export * from "./roll_results_item.vue?vue&type=script&setup=true&lang=js"

import "./roll_results_item.vue?vue&type=style&index=0&id=9f06adf2&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f06adf2"]])

export default __exports__